import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const LocationIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 13.486 15.576">
      <g id="enviroment-o" transform="translate(-0.01 -0.017)">
        <path
          id="Shape"
          d="M6.348,15.452a20.516,20.516,0,0,1-3.663-3.31A12.866,12.866,0,0,1,.811,9.309,7.9,7.9,0,0,1,0,5.917,5.152,5.152,0,0,1,.552,3.6a6.045,6.045,0,0,1,1.48-1.879A7.016,7.016,0,0,1,4.178.463a7.336,7.336,0,0,1,5.128,0,7.016,7.016,0,0,1,2.147,1.264A6.073,6.073,0,0,1,12.933,3.6a5.153,5.153,0,0,1,.552,2.312,7.927,7.927,0,0,1-.812,3.391A12.894,12.894,0,0,1,10.8,12.143a20.52,20.52,0,0,1-3.663,3.31.7.7,0,0,1-.394.124A.692.692,0,0,1,6.348,15.452ZM4.609,1.614A5.776,5.776,0,0,0,2.837,2.657a4.844,4.844,0,0,0-1.183,1.5,3.9,3.9,0,0,0-.423,1.761,6.712,6.712,0,0,0,.694,2.867,11.768,11.768,0,0,0,1.7,2.56,19.372,19.372,0,0,0,3.12,2.874,19.05,19.05,0,0,0,3.12-2.874,11.655,11.655,0,0,0,1.7-2.558,6.705,6.705,0,0,0,.694-2.868,3.938,3.938,0,0,0-.422-1.763,4.785,4.785,0,0,0-1.181-1.5A5.8,5.8,0,0,0,8.874,1.614a6.043,6.043,0,0,0-2.129-.386h0A6.081,6.081,0,0,0,4.609,1.614ZM4.277,8.833a3.488,3.488,0,1,1,2.465,1.02A3.461,3.461,0,0,1,4.277,8.833Zm.212-2.465A2.253,2.253,0,1,0,6.742,4.115,2.255,2.255,0,0,0,4.489,6.368Z"
          transform="translate(0.01 0.017)"
          fill={props.color || theme.palette.primary.main}
        />
      </g>
    </SvgIcon>
  );
};
